import { Injectable } from '@angular/core';

import type { ApiStatus } from '@amfam/shared/models/lib/api/api-status.model';
import type {
  DecoratedPreference,
  RetrievePreferenceResponse
} from '@amfam/shared/models/lib/billing/bill-account.model';

import { Adapter } from './adapter';

@Injectable({
  providedIn: 'root'
})
export class RetrievePreferenceAdapter implements Adapter<DecoratedPreference | ApiStatus> {
  constructor() {}

  /**
   * Return DecoratedPreference object if pcm is enabled.
   * TODO: Remove else condition, return type ANY once pcm is live
   */

  adapt(item: RetrievePreferenceResponse): DecoratedPreference | ApiStatus {
    return {
      billAccountNumber: (item.billAccount.billAccountNumber ?? '').replace(/-/g, ''),
      billingPreferences: {
        accountNickName: item.billAccount.billingPreference?.accountNickname,
        dueDateReminder: item.billAccount.billingPreference?.dueDateReminder,
        preferences: item.billAccount.billingPreference?.preferences
      }
    };
  }
}
